"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // generate an auth state key

var generateAuthStateKey = function generateAuthStateKey() {
  // epoch date
  var epoch = new Date().getTime(); // random string

  var randomString = Math.random().toString(36).slice(2); // concat to form key

  return "auth-sc-".concat(epoch, "-").concat(randomString);
};

var _default = generateAuthStateKey;
exports.default = _default;